<template>
  <div>
    <sub-header :customCrumbLists="customBredCrumbs" showOnlyCustomCrumbs />
    <div class="flex relative flex-1 flex-col flex-grow max-h-full max-w-full">
      <!-- @on-sort-change="onSortChange" -->
      <!-- :sort-options="{
          enabled: true,
        }" -->
      <!--  @on-page-change="onPageChange($event)"
        @on-per-page-change="onPerPageChange($event)" -->
      <vue-good-table-wrapper
        id="pendingApprovalList"
        :rows="filteredRows(getRows)"
        :columns="columnsList"
        :isLoading="loadingState.pendingApproval"
        :pagination-options="paginationOptions"
        :key="pageData?.total"
      >
        <template #column-filter="{ column }">
         <Dropdown
            class="filter-dropdown text-center"
            :placeholder="$t('general.dropdown_placeholder')"
            v-if="column?.filterOptions?.enabled"
            :options="getFilterOptions(column)"
            v-model="filters[column.field]"
            @input="(value) => { updateFilters(column, value)}"
            :config="{ limit: 1 }"
            :colors="{ optionText: 'black' }"
            :reposition="true"
            searchable
            multiple
            maxWidth="100%"
            width="100px"
            minWidth="100%"
        >
        </Dropdown>
        </template>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'roles'" class="flex gap-3">
            <div class="flex gap-2">
              <template>
                <div
                  v-for="(role, indx) in props.row.roles"
                  :key="indx"
                  class="bg-blue-100 text-primary text-sm shadow truncate px-1 rounded font-normal"
                  :title="role.name"
                >
                  {{ role.name }}
                </div>
              </template>
            </div>
          </div>
          <div
            v-else-if="props.column.field === 'groups'"
            class="flex gap-3"
          >
            <div class="flex gap-2">
              <template>
                <div
                  v-for="(group, indx) in props.row.groups"
                  :key="indx"
                  class="bg-blue-100 text-primary text-sm shadow truncate px-1 rounded font-normal"
                  :title="group.name"
                >
                  {{ group.name }}
                </div>
              </template>
            </div>
          </div>
          <div
            v-else-if="props.column.field == 'action'"
            class="flex justify-center cursor-pointer"
          >
            <div class="flex items-center justify-between gap-2">
              <div :class="props?.row?.status === 'REJECTED' ? 'text-gray-500 cursor-not-allowed opacity-50' : 'cursor-pointer text-error'" @click="handleDecline(props.row)">
                {{ $t('actions.decline') }}
              </div>
              <div :class="props?.row?.status === 'REJECTED' ? 'text-gray-500 cursor-not-allowed opacity-50' : 'cursor-pointer text-success'"  @click="handleAccept(props.row)">
                {{ $t('actions.accept') }}
              </div>
            </div>
          </div>
          <div v-else>
              {{ props.row[props.column.field] }}
          </div>
        </template>

        <template #loadingContent>
          <div class="w-full py-10 justify-center flex">
            <Loader />
          </div>
        </template>
        <template #emptystate>
          <div
            class="alert alert-info py-5 my-5"
            v-if="!loadingState.pendingApproval && !pendingApprovalList.length"
          >
            {{ $t('components.dashboard_components.no_data_found') }}
          </div>
          <div v-else class="py-16"></div>
        </template>
      </vue-good-table-wrapper>
      <!-- <button
        v-if="
          selectedDropDownItems && Object.keys(selectedDropDownItems).length
        "
        class=" cursor-pointer py-1 px-3 bg-gray-100 hover:bg-gray-200 rounded-md text-xs text-black flex justify-center items-center font-semibold absolute left-2 top-2 z-50"
        @click="clearFilters"
      >
        Clear filters
      </button> -->
    </div>

    <AddUserModal
      :user="userData"
      ref="AddUserModal"
      @handleSubmit="approveUser($event)"
      :roles="roles"
      :groups="groups"
      :loadingState="loadingState"
      rolesLabel="Roles"
      groupLabel="Groups"
      modalType="approveUser"
      submitButtonText="Approved"
    />

    <ModalConfirm title="Are you sure?" message="" ref="confirm-popup">
    </ModalConfirm>
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import axios from "@/axios";
import Loader from "@shared/loader";
import { uniq } from "lodash"
import AddUserModal from "@shared/components/addUserModal";
import Dropdown from "@shared/components/dropdown-base";
const ModalConfirm = () => import("@/components/modal-confirm");
import { EventBus } from "@/main.js";
import { checkPermission } from "@shared/utils/functions"


export default {
  name: "PendingApprovals",
  components: {
    SubHeader,
    Loader,
    AddUserModal,
    Dropdown,
    ModalConfirm,
  },
  data() {
    return {
      columns: [{
            label: "User Name",
            field: "user_name",
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
            },
        },
        {
            label: "Email",
            field: "email",
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
                query_key: "email",
            },
        },
        {
            label: "User Position",
            field: "position",
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
            },
        },
        {
            label: "Telephone",
            field: "mobile",
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
            },
        },
        {
            label: "Role",
            field: "roles",
            sortable: false,
            width: "100px",
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
                query_key: "roles",
            },
        },
        {
            label: "Group",
            field: "groups",
            sortable: true,
            filterOptions: {
                enabled: true, // enable filter for this column
                isLoading: false,
                query_key: "groups",
            },
        },
        {
          label: "Authentication Method",
          field: "authentication_method",
          filterOptions: {
            enabled: false, // enable filter for this column
            multi: true,
            isLoading: false,
            query_key: "username",
          },
        },
        {
          label: "Status",
          field: "status",
          filterOptions: {
            enabled: false, // enable filter for this column
            multi: true,
            isLoading: false,
            query_key: "username",
          },
        },
        {
          label: "Action",
          field: "action",
          filterOptions: {
            enabled: false, // enable filter for this column
            multi: true,
            isLoading: false,
            query_key: "username",
          },
        }
      ],
      searchParams: null,
      pendingApprovalList: [],

      loadingState: {
        pendingApproval: false,
        roles: false,
        groups: false,
      },
      pageData: null,
      perPage: 10,
      roles: [],
      groups: [],
      userData: {
        username: "",
        email: "",
        roles: [],
        groups: [],
        mobile: "",
        position: "",
      },
      selectedRow: null,
      clientId: null,
      filters:{
          user_name: [],
          email: [],
          position: [],
          mobile: [],
          roles: [],
          groups: []
      },
    };
  },
  async mounted() {
    this.clientId = this.$route.params.clientId;
    this.fetchRoles();
    this.fetchGroups();
    this.pendingApprovalList = await this.fetchPendingApprovalList();
  },
  computed: {
    customBredCrumbs() {
      return [
        { name: this.$t('routes.admin') },
        { name: this.$t('routes.pending_approval') }
      ];
    },
    getRows() {
      return this.pendingApprovalList;
    },
    columnsList() {
      return this.columns.map((column) => ({
          ...column,
          label: this.$t(`pages.user_details.${column.field}`)
      }));
    }, 
    paginationOptions() {
      return {
        nextLabel: this.$t('actions.next'),
        prevLabel: this.$t('actions.previous'),
        rowsPerPageLabel: this.$t('components.rows_per_page'),
        enabled: true,
        mode: 'records',
        dropdownAllowAll: false,
        perPage: this.perPage,
      }
    },
  },
  methods: {
    checkPermission,
    async approveUser(item) {
      try {
        delete item.position;
        delete item.mobile;

        const userData = {...item, groups: item.groups.map((group) => ({name: group.name, id: group.id})),
        roles: item.roles.map((role) => ({name: role.name, id: role.id}))}
        this.selectedRow = {...this.selectedRow, groups: userData.groups,
        roles: userData.roles, email: userData.email, user_name: userData.username }
        delete this.selectedRow.vgt_id;
        delete this.selectedRow.originalIndex;
        const res = await axios.post(`user/approve`, this.selectedRow);
        if(res) {
          this.pendingApprovalList = await this.fetchPendingApprovalList();
          this.$refs["AddUserModal"].closeModal();
        }
      } catch (err) {
        this.$toast.error(err?.response?.data?.detail || this.$t('general.default_error'));
        this.$refs["AddUserModal"].closeModal();
      }


    },
    async fetchRoles() {
      this.loadingState.roles = true;
      try {
        let { data } = await axios.get(`role/client/${this.clientId}`);
        this.roles = data;
      } catch (error) {
        console.log(error, ">>>>error");
      }
      this.loadingState.roles = false;
    },
    async fetchGroups() {
      this.loadingState.groups = true;
      try {
        let { data } = await axios.get(`group/client/${this.clientId}`);
        this.groups = data;
      } catch (error) {
        console.log(error, ">>>>error");
      }
      this.loadingState.groups = false;
    },
    async handleDecline(row) {
      if (row?.status === 'REJECTED') return;
      const promise = await this.$refs["confirm-popup"].show({
        title: this.$t('general.are_you_sure'),
        message: this.$t('pages.user_details.decline_confirm'),
        buttonText: this.$t('actions.confirm'),
      });

      if (promise) {
        try {
          const res = await axios.post(`user/reject/${row.id}`);
          if(res) {
            this.pendingApprovalList = await this.fetchPendingApprovalList();
          }
        } catch(err) {
          this.$toast.error(err?.response?.data?.detail || this.$t('general.default_error'));
          this.$refs["confirm-popup"].close();
        }

      }
      this.$refs["confirm-popup"].close();
    },
    handleAccept(row) {
      if (row?.status === 'REJECTED') return;
      this.selectedRow = row;
      this.userData.username = row.user_name;
      this.userData.email = row.email;
      this.userData.roles = row.roles.map((role) => ({...role, title: role.name}));
      this.userData.groups = row.groups.map((group) => ({...group, title: group.name}));
      this.$refs["AddUserModal"].showUserModal();
    },
    async fetchPendingApprovalList() {
      this.loadingState.pendingApproval = true;
      if(!checkPermission('pending_approval.edit')){
        this.columns = this.columns.filter(el => el.field !== "action");
      }
      let url = `user/client/${this.clientId}/pending`;
      try {
        const response = await axios.get(url);
        this.loadingState.pendingApproval = false;
        let pendingApprovalCount = response.data.filter((el) => el.status === 'PENDING').length;
        EventBus.$emit("updateCountForPendingApproval", pendingApprovalCount);
        return response.data;
      } catch (error) {
        this.loadingState.pendingApproval = false;
        this.$toast.error(
          error?.response?.data?.detail || this.$t('general.default_error')
        );
      }

    },
    getFilterOptions(column){
        let result = this.getRows.length ? this.getRows.filter((el)=> el[column.field] != null ).map((el)=>el[column.field]): [];
        if(column.field === "roles" || column.field === "groups"){
            return uniq(result.flat().map((el)=>el.name)) || []
        }
        return uniq(result)
    },
    updateFilters(column, value) {
        if (this.filters?.[column.field]) this.filters[column.field] = value;
    },
    filteredRows(result){
        for (let filter in this.filters) {
            if (this.filters[filter]?.length) {
                if(filter==="roles" || filter==="groups"){
                    for(let fil of this.filters[filter]){
                        result = this.getRows.filter((row)=>{
                            for(let obj of row[filter]){
                                if(obj.title===fil){
                                    return true;
                                }
                            }

                        })
                    }
                }
                else{
                  result = result.filter((el) => this.filters[filter].includes(el[filter]));
                }
            }
        }
        return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@shared/assets/mixins/mixins.scss";
@include tableComponent;
.filter-dropdown {
  @apply border-transparent bg-white;
}
</style>
